import React from 'react'
import PropTypes from 'prop-types'

import ImageLoader from "components/ImageCarousel/components/ImageLoader"
import DownloadButton from './components/DownloadButton'

import styles from './styles'

const CarouselImage = (props) => {
  const { item } = props

  const classes = styles()

  return (
    <div className={classes.carouselImage}>
      <div className={classes.description}>
        <h3>{item.description}
          {item.originalImageName && <DownloadButton fileName={item.originalImageName} />}
        </h3>
      </div>
      <ImageLoader item={item}></ImageLoader>
    </div>
  )
}

CarouselImage.propTypes = {
  item: PropTypes.shape({
    optimizedImageName: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    alt: PropTypes.string,
    originalImageName: PropTypes.string.isRequired,
  }).isRequired,
}

export default CarouselImage
